import React, { useState } from 'react';
import {
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateButtonStyle, removeButtonStyle } from '../../../common/CSS/css-configs';
import { useEffect } from 'react';

const FieldVisibilitySelector = ({ isOpen, handleClose, onSubmit, fieldVisibility = [] }) => {
  useEffect(()=>{
    setRows(fieldVisibility);

  }, [fieldVisibility]);

  const [rows, setRows] = useState(fieldVisibility);

  const statusOptions = ['awaitingVentiaApproval', 'awaitingCustomerApproval', 'complete'];
  const visibilityOptions = ['hidden', 'display', 'editable' ];

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const handleAddRow = () => setRows([...rows, { status: '', visible: '' }]);

  const handleRemoveRow = (index) => {
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated);
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit(rows);
    handleClose();
  };

  const removeVisibility = () => {
    console.log("Remove Visibitliy!!");
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="field-visibility-selector-title"
      aria-describedby="field-visibility-selector-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
          width: '500px',
          outline: 'none',
        }}
      >
        <h3>Field Visibility</h3>
        <hr />


        <Table size="small" sx={{ mt: 1 , padding: 0, border: '1px solid #ccc',}}>
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Visibility</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Select
                    value={row.status}
                    onChange={(e) => handleChange(index, 'status', e.target.value)}
                    fullWidth
                    displayEmpty
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select Status</em>
                    </MenuItem>
                    {statusOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>

                <TableCell>
                  <Select
                    value={row.visible}
                    onChange={(e) => handleChange(index, 'visible', e.target.value)}
                    fullWidth
                    displayEmpty
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select Visibility</em>
                    </MenuItem>
                    {visibilityOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>

                  <TableCell align="right">
                    <IconButton onClick={() => handleRemoveRow(index)}>
                      <DeleteIcon sx={{ color: 'red' }} />
                    </IconButton>
                  </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button
            variant="contained"
            color="primary"
            onClick={handleAddRow}
            fullWidth
            sx={{
                mt:1,
                mb:2,
                backgroundColor: 'var(--button-color)',
                color: 'white',
                fontWeight: 'normal',
                textTransform: 'none',
                ":hover": {
                backgroundColor: 'var(--button-hover-color)',
                },
            }}
            >
            Add Row
            </Button>
        </Box>
        {/* Cancel and Submit Buttons Below, spaced apart */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={updateButtonStyle}
          >
            Update
          </Button>          
          <Button
            variant="contained"
            color="secondary"
            onClick={removeVisibility}
            sx={removeButtonStyle}
          >
            Remove
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FieldVisibilitySelector;
